import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ReturnStruct } from '../../structs/return.struct';
import { GetLancamentosRequest } from '../../requests/financas/get-lancamentos-conciliacao.request';
import { GetLancamentosResponse } from '../../responses/financas/get-lancamentos-conciliacao.response';
import { ConciliarCartaoCreditoRequest } from '../../requests/financas/conciliar-cartao.request';
import { BuscarParaAssociarCartaoRequest } from '../../requests/financas/buscar-para-associar-cartao.request';
import { BuscarParaAssociarCartaoResponse } from '../../responses/financas/buscar-para-associar-cartao.response';
import { GetLancamentosConciliadosRequest } from '../../requests/financas/get-lancamentos-conciliados.request';
import { GetLancamentosConciliadosCartaoResponse } from '../../responses/financas/get-lancamentos-conciliados-cartao.response';
import { DesconciliarRequest } from '../../requests/financas/desconciliar.request';

@Injectable({ providedIn: 'root' })
export class ConciliacaoCartaoCreditoService extends CommonService {
  private readonly apiUrl = `${environment.urlApiFinancas}conciliacaocartaocredito/`;

  constructor(private httpClient: HttpClient) {
    super();
  }

  public getLancamentos(request: GetLancamentosRequest): Observable<GetLancamentosResponse> {
    return this.httpClient
      .post<GetLancamentosResponse>(`${this.apiUrl}getLancamentos`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public buscarParaAssociar(request: BuscarParaAssociarCartaoRequest): Observable<BuscarParaAssociarCartaoResponse> {
    return this.httpClient
      .post<BuscarParaAssociarCartaoResponse>(`${this.apiUrl}buscarParaAssociar`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public conciliar(request: ConciliarCartaoCreditoRequest): Observable<ReturnStruct> {
    return this.httpClient
      .post<ReturnStruct>(`${this.apiUrl}conciliar`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public getLancamentosConciliados(request: GetLancamentosConciliadosRequest): Observable<GetLancamentosConciliadosCartaoResponse> {
    return this.httpClient
      .post<GetLancamentosConciliadosCartaoResponse>(`${this.apiUrl}getLancamentosConciliados`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public desconciliar(request: DesconciliarRequest): Observable<ReturnStruct> {
    return this.httpClient
      .post<ReturnStruct>(`${this.apiUrl}desconciliar`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public ignorar(idExtratoBancario: number): Observable<ReturnStruct> {
    return this.httpClient
      .delete<ReturnStruct>(`${environment.urlApiFinancas}conciliacaobancaria/ignorar/idExtratoBancario/${idExtratoBancario}`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
